import React, { useState, useEffect } from 'react';
import { createContextHook } from 'use-context-hook';
import linkedinService from '../services/linkedinService';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from './authContext';

const context = {};

export const SubListLeadsContext = createContextHook(context);

export function SubListLeadsContextProvider({ children }) {
  const [subListName, setSubListName] = useState('');
  const [filters, setFilters] = useState(null);
  const [inCampaign, setInCampaign] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);

  const { fetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
  }));

  const { leads_data, leads_loading } = linkedinService.GetAllSubListLeads(searchQuery, fetch);
  useEffect(() => {
    if (leads_data) {
      const name = leads_data?.subListName;
      if (name) {
        setSubListName(name);
      }
      
      const listFilters = leads_data?.filters;
      if (listFilters) {
        setFilters(listFilters);
      }

      const campaignStatus = leads_data?.inCampaign;
      if (typeof campaignStatus === 'boolean') {
        setInCampaign(campaignStatus);
      }
    }
  }, [leads_data]);

  const updateSearchQuery = newQuery => {
    setSearchQuery(newQuery);
  };

  const value = {
    leadsData: leads_data,
    leadsLoading: leads_loading,
    subListName,
    filters,
    inCampaign,
    updateSearchQuery,
  };

  return <SubListLeadsContext.Provider value={value}>{children}</SubListLeadsContext.Provider>;
}
